import { GoBack } from '@/scopes/prices/components/GoBack'
import { GridTabsProvider } from '@/scopes/prices/components/GridTabsContext'
import { PriceConfigurator } from '@/scopes/prices/components/PriceTable/PriceConfigurator'
import {
  getFiltersSelector,
  getPromotedPriceSelector,
  isPriceTableLoadingStateSelector,
} from '@/scopes/prices/components/selectors'
import UrgencyCampaign from '@/scopes/prices/components/UrgencyCampaign'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { mqMax, mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { IndeterminateProgressCircle } from '@sunwebgroup/ui-components/uds'
import { css, styled } from 'styled-components'

const Wrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;

  ${({ $disabled }) =>
    $disabled
    && css`
      opacity: 0.25;
      pointer-events: none;
    `}
`

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${space('primitives_space_16')};
  margin-bottom: ${space('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${space('primitives_space_24')};
    margin-bottom: ${space('primitives_space_24')};
  }
`

const CenterContainer = styled.div`
  margin-top: ${tokPx('primitives_space_80')};
  display: flex;
  justify-content: center;
`

interface PriceTableProps {
  onClickBack?: () => void
}

const GoBackButtonWrapper = styled.div`
  @media (${mqMax('primitives_breakpoint_s_max')}) {
    padding-left: ${space('primitives_space_16')};
  }
`

export function PriceTable({ onClickBack }: PriceTableProps) {
  const { loading: filtersLoading } = usePricesSelector(getFiltersSelector)
  const { data } = usePricesSelector(getPromotedPriceSelector)
  const isLoading = usePricesSelector(isPriceTableLoadingStateSelector)

  if (filtersLoading) {
    return (
      <CenterContainer>
        <IndeterminateProgressCircle />
      </CenterContainer>
    )
  }

  return (
    <GridTabsProvider>
      <Wrapper $disabled={isLoading} data-qa-pt-ready={!isLoading}>
        <HeaderSection>
          <UrgencyCampaign price={data?.price} campaignId={data?.campaignId} />
          <GoBackButtonWrapper>
            <GoBack onClick={onClickBack} />
          </GoBackButtonWrapper>
        </HeaderSection>
        <PriceConfigurator />
      </Wrapper>
    </GridTabsProvider>
  )
}
